import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Dialog } from '@progress/kendo-react-dialogs';
import I18n, { translate } from '@utils/i18n';
import { downloadCsvBuildingsPath } from 'routes';
import { Button } from '@ui';

const namespace = 'features.buildings.buildings_index.export_csv_modal';

function BuildingsExportCsvModal({ buildingIds, disabled, queryParams }) {
  const [visible, setVisible] = React.useState(false);
  const [includeInactive, setIncludeInactive] = React.useState(false);

  const toggleDialog = useCallback(() => {
    setVisible((prevState) => {
      if (prevState) setIncludeInactive(false);
      return !prevState;
    });
  }, []);

  const onSubmit = useCallback(() => {
    const params = new URLSearchParams(queryParams);
    if (includeInactive) {
      params.set('include_inactive', 'true');
    }
    if (buildingIds) {
      params.append('checked_ids', buildingIds);
    } else {
      params.append('all', true);
    }

    fetch(`${downloadCsvBuildingsPath()}?${params}`, {
      headers: { Accept: 'application/json' }
    })
      .then((res) => res.json())
      .then((data) => {
        if (window.toastr) {
          window.toastr.success(data.message);
        } else {
          alert(data.message);
        }
        toggleDialog();
      })
      .catch((error) => {
        console.error('Export failed:', error);
        if (window.toastr) {
          window.toastr.error(translate('error', { namespace }));
        } else {
          alert(translate('error', { namespace }));
        }
      });
  }, [buildingIds, includeInactive, queryParams, toggleDialog]);

  return (
    <>
      <Button tabIndex="0" disabled={disabled} onClick={toggleDialog}>
        <i className="fa-light fa-file-export" />
        {translate('button', { namespace })}
      </Button>
      {visible && (
        <Dialog title={translate('title', { namespace })} className="qmb-dialog" onClose={toggleDialog}>
          <p>
            {buildingIds ? translate('hint_text_selected', { namespace }) : translate('hint_text_all', { namespace })}
          </p>
          <label>
            <input type="checkbox" checked={includeInactive} onChange={(e) => setIncludeInactive(e.target.checked)} />
            {` ${translate('include_inactive', { namespace })}`}
          </label>
          <div className="modal__footer pull-right" style={{ justifyContent: 'space-between' }}>
            <div className="mt-3">
              <button type="button" className="qmb-button" onClick={toggleDialog}>
                {I18n.t('generic.cancel')}
              </button>
              <button type="button" className="qmb-button--submit" onClick={onSubmit}>
                {I18n.t('generic.ok')}
              </button>
            </div>
          </div>
        </Dialog>
      )}
    </>
  );
}

BuildingsExportCsvModal.propTypes = {
  buildingIds: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  disabled: PropTypes.bool.isRequired,
  queryParams: PropTypes.object.isRequired
};

BuildingsExportCsvModal.defaultProps = {
  buildingIds: null
};

export default BuildingsExportCsvModal;
